export interface SpecialItem {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  memberIds: string[];
  relatedIds: string[];
}

export const specialList: SpecialItem[] = [
  {
    id: "sp-01",
    title: "悬疑叙事专场",
    subtitle: "在迷雾中寻找那一束真相之光",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20banner%20of%20a%20foggy%20city%20alley%20with%20a%20single%20warm%20streetlamp%20glow%2C%20deep%20grey%20and%20warm%20amber%20tones%2C%20soft%20gradient%20simple%20background%2C%20moody%20atmospheric%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20consistent%20series%20banner%20style&width=1400&height=700&seq=pcm-sp-01&orientation=landscape",
    intro:
      "当真相被层层迷雾包裹，故事便有了扣人心弦的力量。本专题精选近年备受关注的悬疑题材影视作品，从犯罪推理到心理博弈，带你走进那些需要在黑暗中寻找微光的夜晚。",
    memberIds: ["mv-04", "mv-08", "mv-17", "tv-06", "tv-07", "tv-18"],
    relatedIds: ["sp-02", "sp-03"],
  },
  {
    id: "sp-02",
    title: "城市与人的故事",
    subtitle: "在街巷烟火里，看见平凡人的坚持",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20banner%20of%20a%20warm%20city%20skyline%20at%20dusk%20with%20lit%20windows%20and%20soft%20haze%2C%20warm%20orange%20and%20slate%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20glowing%20evening%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20consistent%20series%20banner%20style&width=1400&height=700&seq=pcm-sp-02&orientation=landscape",
    intro:
      "城市很大，故事很小。本专题聚焦都市与家庭题材，讲述普通人在日常里相互扶持、在变化中努力向前的故事。那些看似平常的细碎时刻，恰恰最能让人感同身受。",
    memberIds: ["mv-20", "tv-01", "tv-02", "tv-10", "tv-15", "a-01"],
    relatedIds: ["sp-04", "sp-06"],
  },
  {
    id: "sp-03",
    title: "古装美学图鉴",
    subtitle: "一砖一瓦，皆是时代的呼吸",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20banner%20of%20ancient%20chinese%20palace%20rooftops%20under%20a%20wide%20golden%20sky%2C%20warm%20amber%20and%20ink%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20epic%20sunset%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20consistent%20series%20banner%20style&width=1400&height=700&seq=pcm-sp-03&orientation=landscape",
    intro:
      "从建筑到服饰，从器物到礼仪，古装作品用影像为时代立传。本专题汇集多部在美术设计上颇受好评的古装题材作品，一起感受那些被精心还原的东方美学。",
    memberIds: ["mv-09", "tv-06", "tv-20", "a-02"],
    relatedIds: ["sp-01", "sp-05"],
  },
  {
    id: "sp-04",
    title: "治愈系影像清单",
    subtitle: "慢下来，把生活调成喜欢的频道",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20banner%20of%20a%20sunny%20quiet%20seaside%20village%20with%20soft%20waves%20and%20warm%20light%2C%20soft%20peach%20and%20pale%20blue%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20gentle%20daylight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20consistent%20series%20banner%20style&width=1400&height=700&seq=pcm-sp-04&orientation=landscape",
    intro:
      "不必总有跌宕起伏，平静本身也是一种力量。本专题收录一批节奏舒缓、画面清新的治愈系作品，适合在一个不赶时间的下午，慢慢看完。",
    memberIds: ["mv-07", "mv-19", "tv-12", "tv-17", "tv-03"],
    relatedIds: ["sp-02", "sp-06"],
  },
  {
    id: "sp-05",
    title: "星海与远征",
    subtitle: "把目光投向更远的地方",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20banner%20of%20a%20vast%20warm%20amber%20nebula%20with%20tiny%20spaceship%20silhouette%20and%20star%20field%2C%20cosmic%20orange%20and%20deep%20indigo%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20epic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20consistent%20series%20banner%20style&width=1400&height=700&seq=pcm-sp-05&orientation=landscape",
    intro:
      "科幻的魅力，不只在于想象未来，更在于借由遥远的星海照见当下。本专题精选科幻与冒险题材作品，带你踏上一段关于探索、信任与希望的旅程。",
    memberIds: ["mv-10", "mv-14", "tv-14", "tv-21"],
    relatedIds: ["sp-03", "sp-01"],
  },
  {
    id: "sp-06",
    title: "青春不散场",
    subtitle: "那些明亮的、笨拙的、闪闪发光的年纪",
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20banner%20of%20a%20golden%20hour%20country%20road%20with%20blurred%20cyclists%20and%20warm%20sun%20flare%2C%20warm%20orange%20and%20fresh%20green%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20hopeful%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20consistent%20series%20banner%20style&width=1400&height=700&seq=pcm-sp-06&orientation=landscape",
    intro:
      "青春是一场无论过去多久都想重温的夏天。本专题聚焦青春成长题材，收录那些关于友情、梦想与告别的故事，献给每一个正在或曾经年轻的人。",
    memberIds: ["mv-03", "tv-04", "tv-05", "tv-19"],
    relatedIds: ["sp-04", "sp-02"],
  },
];